import { FormattedMessage } from 'react-intl';
import React from 'react';
import { FULFILLMENTS_DELIVERY_EXCEPTION_VIEW_ID, FULFILLMENTS_VIEW_ID } from './view-id-constants';

export const FulfillmentsDeliveryException = {
  label: (
    <FormattedMessage
      defaultMessage='Delivery Exception'
      description='shipping page left nav item for in Delivery Exception fulfillments'
      id='PkBJ6G'
    />
  ),

  expandedDescription: (
    <FormattedMessage
      defaultMessage='Fulfillments / Delivery Exception'
      description='shipments page grid header, fulfillments.delivery-exception'
      id='PMWmSr'
    />
  ),

  id: FULFILLMENTS_DELIVERY_EXCEPTION_VIEW_ID,
  navigationOverride: '/shipments/fulfillments/delivery-exception',
  parentId: FULFILLMENTS_VIEW_ID,
};
